export const STORAGE = Object.freeze({
  USER_SESSION: '_ios_user_session',
});
